<!-- Inline autoscaling settings form (used in add-service flow) -->
<zui-autoscaling-settings-form
  [value]="valueRef()"
  [serviceStackType]="serviceStackType()"
  [supportsVerticalAutoscaling]="supportsVerticalAutoscaling()"
  [verticalLimits]="defaultVerticalAutoscaling()"
  [horizontalLimits]="defaultHorizontalAutoscaling()"
  [verticalPlaceholder]="verticalPlaceholder()"
  [horizontalPlaceholder]="horizontalPlaceholder()"
  [autoscalingProfiles]="autoscalingProfiles()"
  [isFreeUser]="isFreeUser()"
  [embedded]="true"
  (validationChange)="isFormValid.set($event)"
  (valueChange)="onInlineValueChange($event)"
/>
